import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const useDocumentTitle = (title = "") => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = `${title ? `${title} | ` : ""}${process.env.REACT_APP_APP_NAME ?? "VayKLife Gear"}`;
  }, [title, pathname]);

  return null;
};

export default useDocumentTitle;
